import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext } from "react";
import { Button } from "react-bootstrap";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import SubstituteInstructor from "../SubstituteInstructor";

const UserClass = (props) => {
    const { t } = useTranslation();
    const { c, onShowModal, onlyDisplay, showUA, i } = props;
    const { changeView } = useContext(BasicContext);

    return (
        <Fragment>
            <tr className={`class-lvl-bg-${c.class_level_colour ? c.class_level_colour : "white"} ${c.class_status_code === "CANCELLED" ? "class-cancelled" : ""}`}>
                <td rowSpan={2} className="align-middle pb lh-1 pt-2 border-secondary border-bottom">
                    <FontAwesomeIcon icon={faCalendar} />
                </td>
                <td className="align-middle bold pb-0 lh-1 pt-2  border-bottom-0 user-class-date">{moment(c.class_start_time).format("DD.MM.YYYY")}</td>
                <td className="align-middle bold pb-0 lh-1 pt-2  border-bottom-0">{c.class_name}</td>
                <td className="align-middle text-end lh-1 py-2 border-secondary border-bottom" rowSpan={2}>
                    {c.class_status_code !== "CANCELLED" && (
                        <>
                            {t("status")}:<br />
                            {t(`classes.studentStatus.${c.u2c_status_code}`)}
                            {c.u2c_status_code === "WAITLIST" && (
                                <>
                                    <br />({t("classes.onWaitlist")}: {c.onWaitlist})
                                </>
                            )}
                        </>
                    )}
                </td>
                {c.class_status_code === "CANCELLED" ? (
                    <td className="align-middle pe-0 pe-lg-2 lh-1 py-2 border-secondary border-bottom btn-td  action-btns" rowSpan={2}>
                        <span className="d-block text-end">{t("classes.classCancelled")}</span>
                    </td>
                ) : !onlyDisplay ? (
                    <td className="align-middle pe-0 pe-lg-2 lh-1 py-2 text-center border-secondary border-bottom btn-td" rowSpan={2}>
                        {c.ifUserHasValidReservation ? (
                            <Button size="sm" className={`btn-class btn-outline-${c.class_level_colour}`} onClick={() => changeView({ nav: "reservations", sub: "useReservation" })}>
                                {t("reservations.useReserv")}
                            </Button>
                        ) : c.u2c_status_code === "SIGNED" || c.u2c_status_code === "WAITLIST" ? (
                            <Button className={` btn-class btn-outline-${c.class_level_colour}`} size="sm" onClick={() => onShowModal({ c: c, statusCode: c.u2c_status_code })}>
                                {t("signOut")}
                            </Button>
                        ) : null}
                    </td>
                ) : showUA ? (
                    <td className="align-middle pe-0 lh-1 py-2 text-end pe-2 border-secondary border-bottom" rowSpan={2}>
                        <span>
                            {t("presence")}:<br />
                            {t(`attendanceCodes.${c.ua_status_code}`)}
                        </span>
                    </td>
                ) : null}
            </tr>
            <tr className={`pb-2 class-lvl-bg-${c.class_level_colour ? c.class_level_colour : "white"} ${c.class_status_code === "CANCELLED" ? "class-cancelled" : ""}`}>
                <td className="align-middle bold lh-1 pt-0 pt-lg-2 border-secondary border-bottom">
                    {moment(c.class_start_time).format("HH:mm")}–{moment(c.class_end_time).format("HH:mm")}
                </td>
                <td className={`pb-2 align-middle lh-1 border-secondary border-bottom`}>
                    {c.instructor_label ? <SubstituteInstructor i={i} c={c} /> : `${c.instructor_name} ${c.instructor_surname}`}
                </td>
            </tr>
        </Fragment>
    );
};

export default UserClass;
